import React, { useState, useCallback, useContext, useEffect } from 'react'//,{useState,useCallback}
import styles from './ContactClassification.module.css'
import { Button } from 'react-bootstrap'
// import SettingsDropDown from '../../../UI/SettingsDropDown/SettingsDropDown'
import DropDownV2 from '../../../UI/DropDownV2/DropDownV2';
import { useTranslation } from "react-i18next";
// import AlertContext from '../../../../context/AlertModelContext/AlertModalContext'
import { getDropDownList, updateDropDownList, updateDropDownItem, deleteDropDownItem, deleteDropDown, insertDropDownList } from '../../../../axios/requests/dropDownReq'

const defaultSelectedClassification = {
    key: 'Create',
    value: 'Create'
}

const defaultServiceTypeDropDownObj = {
    name: "Create classification",
    category: "CONTACT_CLASSIFICATION",
    dropDownItems: [
    ]
}

const ContactClassification = (props) => {
    const [t] = useTranslation('common')
    // const alertCtx = useContext(AlertContext)
    const [classificationDropDownList, setClassificationDropDownList] = useState([])
    const [classificationDropDownObj, setClassificationDropDownObj] = useState({})
    const [classificationSelectedItem, setClassificationSelectedItem] = useState({})

    const fetchClassificationDropDownData = useCallback(async () => {

        let classificationDropDownListTemp = await getDropDownList('CONTACT_CLASSIFICATION');
        classificationDropDownListTemp.unshift(defaultServiceTypeDropDownObj)
        classificationDropDownListTemp.forEach((classificationDropDown) => {
            classificationDropDown.dropDownItems.unshift(defaultSelectedClassification)
        })
        setClassificationDropDownList(classificationDropDownListTemp)
        setClassificationDropDownObj(classificationDropDownListTemp[0])
        setClassificationSelectedItem(classificationDropDownListTemp[0].dropDownItems[0])
    }, [setClassificationDropDownObj, setClassificationSelectedItem])

    useEffect(() => {
        fetchClassificationDropDownData()
    }, [])

    const onSelectClassificationObjHandler = useCallback((selectedItem) => {
        setClassificationDropDownObj(selectedItem)
    })

    const onSelectHandler = useCallback((selectedItem) => {
        setClassificationSelectedItem(selectedItem)
    }, [])

    const onClassificationNameChangeHandler = useCallback((e) => {
        e.preventDefault()
        const newValue = e.target.value

        setClassificationDropDownObj((prevState => {
            const newObj = JSON.parse(JSON.stringify(prevState))
            newObj.name = newValue
            return newObj
        }))

    }, [])

    const onClassificationItemNameChangeHandler = useCallback((e) => {
        e.preventDefault()
        const newValue = e.target.value

        setClassificationSelectedItem((prevState => {
            const newObj = JSON.parse(JSON.stringify(prevState))
            newObj.value = newValue
            newObj.key = newValue
            return newObj
        }))

    }, [])

    const onSaveClassificationClickHandler = useCallback(async () => {
        if (!classificationDropDownObj?._id) {
            if (classificationDropDownObj.name === 'Create classification') return
            await insertDropDownList(classificationDropDownObj)
        }
        else {
            await updateDropDownList(classificationDropDownObj._id, classificationDropDownObj)
        }
        fetchClassificationDropDownData()
    }, [classificationDropDownObj, classificationSelectedItem])

    //todo
    const onSaveClassificationItemClickHandler = useCallback(async () => {
        await updateDropDownItem(classificationDropDownObj, classificationSelectedItem)
        fetchClassificationDropDownData()
    }, [classificationDropDownObj, classificationSelectedItem])

    const onDeleteClassificationClickHandler = useCallback(async () => {
        if (!classificationDropDownObj?._id) return
        await deleteDropDown(classificationDropDownObj._id)
        fetchClassificationDropDownData()
    }, [classificationDropDownObj, classificationSelectedItem])

    //todo
    const onDeleteClassificationItemClickHandler = useCallback(async () => {
        await deleteDropDownItem(classificationDropDownObj, classificationSelectedItem)
        fetchClassificationDropDownData()
    }, [classificationDropDownObj, classificationSelectedItem])

    return (
        <>
            <h2 className={styles.settingsTitle} style={{ textDecoration: 'none' }}>{`${t('Classification managment')} :`}</h2>
            <artical className={styles.subSettingSection}>

                <DropDownV2 nowSelected={classificationDropDownObj} onSelect={onSelectClassificationObjHandler} label={'Select a classification'} items={classificationDropDownList} />
                <section >
                    {/* <h2 className={styles.settingsTitle}>{t(classificationDropDownObj.name)}</h2> */}
                    <div className={styles.someSettingDiv}>
                        <span className={styles.specificSettingsText}>{t('Classification name')} </span>
                        <input type='text' value={classificationDropDownObj.name !== 'Create classification' ? t(classificationDropDownObj.name) : ''} onChange={onClassificationNameChangeHandler} className={styles.input} />
                    </div>
                    <div className={styles['dropdown--save-remove']}>
                        <Button className={styles.updateAutoMsgTimeClicked} variant='success' onClick={onSaveClassificationClickHandler} >{t('save')}</Button>
                        {
                            classificationDropDownObj.name !== 'Create classification' && classificationDropDownObj._id && <Button className={styles.updateAutoMsgTimeClicked} variant='danger'
                                onClick={onDeleteClassificationClickHandler}>{t('remove')}</Button>
                        }
                    </div>
                    <div style={{ marginBottom: '20px' }} />
                    {classificationDropDownObj.name !== 'Create classification' && classificationDropDownObj._id &&
                        <>
                            <div className={styles['block-tiny-line']} />
                            <section className={`${styles['double-sub-settingsection']}`}>
                                <DropDownV2 nowSelected={classificationSelectedItem} onSelect={onSelectHandler} label={`${t('Select')} ${classificationDropDownObj.name}`} items={classificationDropDownObj.dropDownItems} />
                                <div className={styles.someSettingDiv}>
                                    <span className={styles.specificSettingsText}>{t('Name')} </span>
                                    <input type='text' value={classificationSelectedItem.key !== 'Create' ? t(classificationSelectedItem.key) : ''} onChange={onClassificationItemNameChangeHandler} className={styles.input} />
                                </div>
                                <div className={styles['dropdown--save-remove']}>
                                    <Button className={styles.updateAutoMsgTimeClicked} variant='success' onClick={onSaveClassificationItemClickHandler} >{t('save')}</Button>
                                    {
                                        classificationSelectedItem.key !== 'Create' && classificationDropDownObj._id && <Button className={styles.updateAutoMsgTimeClicked} variant='danger'
                                            onClick={onDeleteClassificationItemClickHandler}>{t('remove')}</Button>
                                    }
                                </div>
                            </section>
                        </>
                    }

                </section>




            </artical>
        </>
    )
}

export default ContactClassification
